import {
    ProductListInfoDispatcher as SourceProductListInfoDispatcher
} from 'SourceStore/ProductListInfo/ProductListInfo.dispatcher';
import {
    updateActiveFilter,
    updateProductListInfo
} from 'Store/ProductListInfo/ProductListInfo.action';

/** @namespace Bodypwa/Store/ProductListInfo/Dispatcher */
export class ProductListInfoDispatcher extends SourceProductListInfoDispatcher {
    updateActiveFilter(dispatch, activeFilter) {
        return dispatch(updateActiveFilter(activeFilter));
    }

    onSuccess({ products }, dispatch, options) {
        const {
            args: {
                filter
            },
            args
        } = options;

        const filteredItemas = products.filters.filter((filter) => {
            const { filter: { categoryIds }, search } = args;
            const { amshopby_filter_data: { visible_in_categories, categories_filter } } = filter;

            if (visible_in_categories === 'visible_everywhere' || search) {
                return true;
            }
            if (visible_in_categories === 'only_in_selected_categories'
             && categories_filter.indexOf(`${categoryIds}`) !== -1) {
                return true;
            }
            if (visible_in_categories === 'hide_in_selected_categories'
             && categories_filter.indexOf(`${categoryIds}`) !== -1) {
                return false;
            }

            return false;
        });

        const dispatchProducts = { ...products, filters: filteredItemas };

        dispatch(updateProductListInfo(dispatchProducts, filter));
    }
}

export default new ProductListInfoDispatcher();
